import script from "./MapKsb.vue?vue&type=script&setup=true&lang=js"
export * from "./MapKsb.vue?vue&type=script&setup=true&lang=js"

import "./MapKsb.vue?vue&type=style&index=0&id=bf49f466&lang=less"

const __exports__ = script;

export default __exports__